import { AppRouter } from './routes';
import { Provider } from 'react-redux';

import { store } from './redux/store';

export const WebCallApp = () => {
  return (
    <Provider store={store}>
        <AppRouter />
    </Provider>
  )
}
